import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';
import { FaArchive, FaPen, FaTrash } from 'react-icons/fa';

import UserPhoto from '../../../../components/UserPhoto';

export default function CoachesCard(props) {
    if (props.little) {
        return (
            <li className='coaches-card little'>
                <UserPhoto src={props.src} alt='Foto de perfil do aluno' />
                <Link to={`professores/${props.id}`}>
                    <p className='name'><b>{props.name}</b></p>
                </Link>
                {/* <p><b>ID:</b> {props.id}</p> */}
                {/* <p className='age'><b>Idade:</b> {props.age}</p> */}
                <button className={props.active ? 'delete' : 'green'} onClick={() => props.active ? props.onDisable() : props.onActivate()}><FaArchive /></button>

               {/*  <Link className='button edit' to={`professores/${props.id}/editar`}><FaPen /></Link>
                <button className='delete' onClick={() => props.onDelete()}><FaTrash /></button> */}
            </li>
        )
    } else {
        return (
            <li className='coaches-card'>
                <UserPhoto src={props.src} alt='Foto de perfil do aluno' />
                <Link to={`professores/${props.id}`}>
                    <p className='name'><b>{props.name}</b></p>
                </Link>
                <p><b>ID:</b> {props.id}</p>
                <p className='age'><b>Idade:</b> {props.age}</p>
                <button className={props.active ? 'delete' : 'green'} onClick={() => props.active ? props.onDisable() : props.onActivate()}><FaArchive /></button>

                {/* <Link className='button edit' to={`professores/${props.id}/editar`}><FaPen /></Link>
                <button className='delete' onClick={() => props.onDelete()}><FaTrash /></button> */}
            </li>
        )
    }
}